import React, { useState, useEffect, useMemo } from 'react';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
import { useDropzone } from 'react-dropzone';
import Swal from 'sweetalert2';
import { calculateTotal } from '../../libs/sum';

const baseStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  transition: 'border .3s ease-in-out'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

const Debt = () => {
  var [debts, setDebts] = useState([]);
  var [showOverlay, setShowOVerlay] = useState('none');
  var [purchaseId, setPurchaseId] = useState(null);
  var [displayFiles, setDisplayFiles] = useState([]);
  var [isUploading, setIsUploading] = useState(false);

  var {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    multiple: false,
    // react-dropzone v14 requiere accept como objeto {mimeType: [extensiones]},
    // no como string. Incluye heic/heif (fotos de iPhone) porque el backend
    // ahora las convierte a JPEG automáticamente.
    accept: {
      'image/jpeg': ['.jpeg', '.jpg'],
      'image/png': ['.png'],
      'image/heic': ['.heic'],
      'image/heif': ['.heif']
    },
    onDrop: function(files) {
      setDisplayFiles(files);
    },
    onDropRejected: function(rejectedFiles) {
      var rejectedName =
        rejectedFiles && rejectedFiles[0] && rejectedFiles[0].file
          ? rejectedFiles[0].file.name || ''
          : '';
      var isHeic = /\.heic$|\.heif$/i.test(rejectedName);
      Swal.fire({
        icon: 'warning',
        title: 'Formato no válido',
        text: isHeic
          ? 'Tu foto está en formato HEIC (típico de iPhone). Ve a Ajustes > Cámara > Formatos y activa "Más compatible", o adjunta la foto como JPG/PNG.'
          : 'Solo se aceptan imágenes JPG o PNG.'
      });
    }
  });

  useEffect(function() {
    getDebts();
  }, []);

  // Limpiar archivos cuando se cierra el modal
  useEffect(function() {
    if (showOverlay === 'none') {
      setDisplayFiles([]);
    }
  }, [showOverlay]);

  var files = displayFiles.map(function(file) {
    return (
      <li key={file.path || file.name}>
        {file.path || file.name} - {file.size} bytes
      </li>
    );
  });

  var getDebts = async function() {
    try {
      var user = AuthService.getCurrentUser();
      var data = await ApiService.getDebts(user.token);
      setDebts(data.debts);
    } catch (e) {
    }
  };

  var handleSubmit = async function() {
    if (isUploading) return;

    // Validar que haya un archivo seleccionado
    if (!displayFiles || displayFiles.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Aviso',
        text: 'Por favor selecciona un archivo antes de continuar.'
      });
      return;
    }

    if (!purchaseId) {
      Swal.fire({
        icon: 'warning',
        title: 'Aviso',
        text: 'No se ha seleccionado una deuda.'
      });
      return;
    }

    setIsUploading(true);

    try {
      var formData = new FormData();
      formData.append('purchase_id', purchaseId);
      formData.append('file', displayFiles[0]);
      var user = AuthService.getCurrentUser();
      var data = await ApiService.uploadVoucher(user.token, formData);

      setShowOVerlay('none');
      setDisplayFiles([]);

      // Refrescar lista de deudas
      getDebts();

      Swal.fire({
        icon: 'success',
        title: 'Hecho!',
        text: 'Voucher subido correctamente.'
      });
    } catch (error) {
      var message = 'Ocurrió un error al subir el voucher.';
      if (
        error &&
        error.response &&
        error.response.data &&
        typeof error.response.data.message === 'string'
      ) {
        message = error.response.data.message;
      }
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: message
      });
    } finally {
      setIsUploading(false);
    }
  };
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  return (
    <div
      className="cart-container"
      style={{ backgroundColor: '#161616 !important' }}
    >
      <section className="section-b-space">
        <div className="container padding-cls">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="col-md-8">
              <div className="checkout-form">Deuda por pagar</div>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Deuda</th>
                    <th>Pagado</th>
                    <th width="150">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {debts.map(debt => (
                    <tr key={debt.id}>
                      <td align="right">
                      {calculateTotal(parseFloat(debt.total).toFixed(2), parseFloat(debt.delivery).toFixed(2))}
                      </td>
                      <td align="right">{debt.total_charges}</td>
                      <td align="right">
                        <button
                          onClick={() => {
                            setShowOVerlay('block');
                            setPurchaseId(debt.id);
                          }}
                          className="btn btn-sm btn-outline-success"
                        >
                          Pagar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <div
        id="debt"
        className="search-overlay has-debt"
        style={{ display: showOverlay }}
      >
        <div>
          <span
            className="closebtn"
            onClick={function() {
              setShowOVerlay('none');
              setDisplayFiles([]);
            }}
            title="Close Overlay"
          >
            ×
          </span>
          <div className="overlay-content options-overlay-content">
            <div className="container">
              <div>
                <label className="logout-text1"></label>
              </div>
              <div className="row" style={{ display: 'block' }}>
                <div {...getRootProps({ style })}>
                  <input {...getInputProps()} />
                  <p style={{ color: '#000' }}>
                    Arrastra y suelta algunos archivos aquí
                  </p>
                </div>
                <aside>
                  <h4>Archivos</h4>
                  <ul>{files}</ul>
                </aside>
              </div>
              <div className="row div-logout-button">
                <button
                  style={{ position: 'relative' }}
                  className="btn btn-solid btn-explore mt-10"
                  onClick={handleSubmit}
                  disabled={isUploading || displayFiles.length === 0}
                >
                  {isUploading ? 'Subiendo...' : 'Pagar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Debt;
